import { Navigate, Outlet } from "react-router-dom";
import { NavbarBo } from "../components/navbar/NavbarBo";
import Paths from "../constants/paths";
import { getDefaultPagePerRole } from "../lib/roleBasedDefaultPage";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "../components/ui/sidebar";

type ProtectedRouteBoProps = {
  isAuthenticated: boolean;
  role: string | null;
  isBoUser: boolean;
};

export const ProtectedRouteBo = ({ isAuthenticated, role, isBoUser }: ProtectedRouteBoProps) => {
  if (!isAuthenticated) {
    return <Navigate to={Paths.auth.login} />;
  }
  if (!isBoUser) {
    return <Navigate to={getDefaultPagePerRole(role || undefined)} />;
  }
  return (
    <SidebarProvider className="h-screen w-screen overflow-hidden bg-gray-50">
      <NavbarBo role={role || undefined} />
      <SidebarInset className="min-w-0 bg-gray-50">
        <SidebarTrigger className="fixed top-3 left-3 z-50 size-10 rounded-full border border-gray-200 bg-white text-gray-600 shadow-md hover:text-blue-600 md:hidden" />
        <div className="relative flex flex-1 overflow-auto">
          <Outlet />
        </div>
      </SidebarInset>
    </SidebarProvider>
  );
};
